import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  private _count = 0;
  private _counter = new BehaviorSubject<number>(0);
  public numberOfRequests = this._counter.asObservable();

  constructor() { }

  public pushRequest(){    
    this._count = this._count + 1;
    this._counter.next(this._count);
  }

  public pullRequest(){    
    if(this._count > 0){
      this._count = this._count - 1;
      this._counter.next(this._count);
    }    
  }

}